"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var tabsLocal = function tabsLocal(theme) {
  return {
    appearance: {
      primary: {
        textColor: theme.color.monochrome5["default"],
        activeUnderlineColor: theme.color.primary1["default"],
        tabListBottomBorder: "".concat(theme.border.width[1], " ").concat(theme.border.style[1], " ").concat(theme.color.monochrome3["default"]),
        containerFocusShadow: "0 0 0 3px ".concat(theme.color.focus["default"]),
        titleBottomBorder: "4px ".concat(theme.border.style[1], " transparent"),
        titleBottomBorderRadius: theme.border.radius[1],
        hoverFontWeight: "".concat(theme.fontWeight[3]),
        activeTextColor: theme.color.monochrome5["default"],
        activeFontWeight: "".concat(theme.fontWeight[3]),
        textFontWeight: "".concat(theme.fontWeight[3], "}"),
        overflowIcon: {
          appearance: 'primary',
          inverse: false
        },
        inverse: {
          textColor: theme.inverseColor.monochrome5["default"],
          activeUnderlineColor: theme.inverseColor.primary1["default"],
          tabListBottomBorder: "".concat(theme.border.width[1], " ").concat(theme.border.style[1], " ").concat(theme.color.monochrome3["default"]),
          containerFocusShadow: "0 0 0 3px ".concat(theme.color.focus["default"]),
          titleBottomBorder: "4px ".concat(theme.border.style[1], " transparent"),
          titleBottomBorderRadius: theme.border.radius[1],
          hoverFontWeight: "".concat(theme.fontWeight[3]),
          activeTextColor: theme.inverseColor.monochrome5["default"],
          activeFontWeight: "".concat(theme.fontWeight[3]),
          textFontWeight: "".concat(theme.fontWeight[3], "}"),
          overflowIcon: {
            appearance: 'primary',
            inverse: true
          }
        }
      },
      secondary: {
        textColor: theme.color.monochrome5["default"],
        activeUnderlineColor: theme.color.monochrome5["default"],
        tabListBottomBorder: "".concat(theme.border.width[1], " ").concat(theme.border.style[1], " ").concat(theme.color.monochrome3["default"]),
        containerFocusShadow: "0 0 0 3px ".concat(theme.color.focus["default"]),
        titleBottomBorder: "4px ".concat(theme.border.style[1], " transparent"),
        titleBottomBorderRadius: theme.border.radius[1],
        hoverFontWeight: "".concat(theme.fontWeight[3]),
        activeTextColor: theme.color.monochrome5["default"],
        activeFontWeight: "".concat(theme.fontWeight[3]),
        textFontWeight: "".concat(theme.fontWeight[3], "}"),
        overflowIcon: {
          appearance: 'primary',
          inverse: false
        },
        inverse: {
          textColor: theme.inverseColor.monochrome5["default"],
          activeUnderlineColor: theme.inverseColor.monochrome5["default"],
          tabListBottomBorder: "".concat(theme.border.width[1], " ").concat(theme.border.style[1], " ").concat(theme.color.monochrome3["default"]),
          containerFocusShadow: "0 0 0 3px ".concat(theme.color.focus["default"]),
          titleBottomBorder: "4px ".concat(theme.border.style[1], " transparent"),
          titleBottomBorderRadius: theme.border.radius[1],
          hoverFontWeight: "".concat(theme.fontWeight[3]),
          activeTextColor: theme.inverseColor.monochrome5["default"],
          activeFontWeight: "".concat(theme.fontWeight[3]),
          textFontWeight: "".concat(theme.fontWeight[3], "}"),
          overflowIcon: {
            appearance: 'primary',
            inverse: true
          }
        }
      }
    }
  };
};
var _default = tabsLocal;
exports["default"] = _default;
//# sourceMappingURL=Tabs.theme.js.map